import type { NavigationParameters } from '../index.h'

/**
 * Custom event for `navigate`. (Not analytix one)
 */
export class NavigateEvent {
  static topic = 'navigate'
  to: string
  from?: string
  type?: string
  search?: string
  timestamp?: number

  constructor({ to, from, type, search, timestamp }: NavigationParameters) {
    this.to = to
    this.from = from
    this.type = type
    this.search = search
    this.timestamp = timestamp
  }
}
